import { render, staticRenderFns } from "./GenelBorcAlacak.vue?vue&type=template&id=06f80236&scoped=true"
import script from "./GenelBorcAlacak.vue?vue&type=script&lang=js"
export * from "./GenelBorcAlacak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f80236",
  null
  
)

export default component.exports